import React from 'react'
import Modal from 'react-modal'

// Whichever element has this id will be the parent in the DOM for the dialog.
export const DIALOG_PARENT_ID = 'Mission-Player--dialog-parent-id'
// Whichever element has this id will be a sibling in the DOM for the dialog.
export const DIALOG_SIBLING_ID = 'Mission-Player--dialog-id'

/**
 * A wrapper around react-modal that sets the appElement and parentSelector.
 * This is a workaround for when react-modal needs to appear while the browser is in fullscreen mode.
 * It also ensures that the mission-player react modal will appear under any mission controller frame content.
 * @param {Object} props
 */
export default function ReactModal(props: {
	appElement?: Element | null,
	parentSelector?: () => HTMLElement | null,
}): React$Node {
	if (
		document.getElementById(DIALOG_PARENT_ID) &&
		document.getElementById(DIALOG_SIBLING_ID)
	) {
		props.parentSelector = () => document.getElementById(DIALOG_PARENT_ID)
		props.appElement = document.getElementById(DIALOG_SIBLING_ID)
	}

	return <Modal {...props} />
}
